module.exports = __webpack_public_path__ + "media/Video 46a.6dff2c83.mp4";